import { Box, Container, Heading, Button, Text } from '@chakra-ui/react';
import { IconBoxAlignBottomFilled } from '@tabler/icons-react';
import { useRouter } from 'next/router';
import { TextBlock } from 'types/umbraco';

export default function TextBlock({
  backgroundColor,
  text,
  textColor,
  button,
  buttonStyle,
}: TextBlock['properties']): JSX.Element {
  const router = useRouter();

  const buttonData = button && Array.isArray(button) && button.length > 0 
    ? button[0] 
    : null;

  const bgColor = backgroundColor && backgroundColor.value 
    ? backgroundColor.value 
    : '#fff';
  const textColorValue = textColor && textColor.value 
    ? textColor.value 
    : '#000';


  if (!text?.markup) {
    return null;
  }

  return (
    <Box bg={bgColor} pos="relative" py={12}>
      <Container maxW="7xl">
        {text && text.markup && (
        <Box
          className="umb-text-block"
          color={textColorValue}
          mb={6}
          sx={{
            '& p': {
              fontSize: 'md',
              lineHeight: '1.6',
            },
          }}
          dangerouslySetInnerHTML={{ __html: text.markup }}
        />
        )}
        {buttonData && buttonData.title && (
          <Button
            as="a"
            href={buttonData.route?.path || buttonData.url}
            target={buttonData.target}
            variant={buttonStyle?.toLowerCase() || 'orange'}
          >
            {buttonData.title}
          </Button>
        )}
      </Container>
    </Box>
  );
}
